export default __webpack_public_path__ + "static/media/recebido_marker.80a4918b.svg";